import {Button} from '@wandb/components';
import * as React from 'react';
import {useParams} from 'react-router';

import {trackObservabilityRunIssuesButton} from '../../../services/analytics/observabilityEvents';
import {
  useActiveErrorDrawer,
  useActiveIssues,
} from '../../../state/issues/hooks';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawerContextProvider';

export const RunIssuesButton = () => {
  const activeIssues = useActiveIssues();
  const activeErrorDrawer = useActiveErrorDrawer();
  const {toggleWorkspaceDrawer} = useWorkspaceDrawerContext();
  const {entityName, projectName} = useParams<{
    entityName: string;
    projectName: string;
  }>();
  return (
    <Button
      startIcon="warning"
      onPress={() => {
        trackObservabilityRunIssuesButton({
          action: 'Click run issues button',
          entityName: entityName ?? '',
          projectName: projectName ?? '',
        });
        toggleWorkspaceDrawer('run-issues');
      }}
      variant="secondary">
      {activeErrorDrawer ? 'Issues' : `Issues (${activeIssues.length})`}
    </Button>
  );
};
